import {cityNameWhere, cityPronounWhere} from "./city_name_declination_utils";
import {formatPercent} from "./format_price_m2";
import {ITransactionPriceRow} from "./get_transaction_price_rows";
import {ITransactionPricesSummary} from "./get_transaction_prices_summary";

export interface ITransactionPricesGapCity {
    slug: string;
    name: string;
    /** Locative form, for the sentence that puts the city after a preposition. */
    nameWhere: string;
    differenceLabel: string;
}

export interface ITransactionPricesGapNote {
    /** "w" or "we", chosen for the first city of the widest list - the only one the sentence names it for. */
    widestPreposition: string;
    widestCities: ITransactionPricesGapCity[];
    narrowestCities: ITransactionPricesGapCity[];
}

const toGapCity = (row: ITransactionPriceRow): ITransactionPricesGapCity => ({
    slug: row.slug,
    name: row.name,
    nameWhere: cityNameWhere(row.name),
    differenceLabel: formatPercent(Math.abs(row.differencePct))
});

export const getTransactionPricesGapNote = (summary: ITransactionPricesSummary): ITransactionPricesGapNote | null => {
    const {widestGaps, narrowestGaps} = summary;

    if (widestGaps.length === 0) {
        return null;
    }

    return {
        widestPreposition: cityPronounWhere(widestGaps[0].name),
        widestCities: widestGaps.map(toGapCity),
        narrowestCities: narrowestGaps.map(toGapCity)
    };
};
import {cityNameWhere, cityPronounWhere} from "./city_name_declination_utils";
import {formatPercent} from "./format_price_m2";
import {ITransactionPriceRow} from "./get_transaction_price_rows";
import {ITransactionPricesSummary} from "./get_transaction_prices_summary";

export interface ITransactionPricesGapCity {
    slug: string;
    name: string;
    /** Locative form, for the sentence that puts the city after a preposition. */
    nameWhere: string;
    differenceLabel: string;
}

export interface ITransactionPricesGapNote {
    /** "w" or "we", chosen for the first city of the widest list - the only one the sentence names it for. */
    widestPreposition: string;
    widestCities: ITransactionPricesGapCity[];
    narrowestCities: ITransactionPricesGapCity[];
}

const toGapCity = (row: ITransactionPriceRow): ITransactionPricesGapCity => ({
    slug: row.slug,
    name: row.name,
    nameWhere: cityNameWhere(row.name),
    differenceLabel: formatPercent(Math.abs(row.differencePct))
});

export const getTransactionPricesGapNote = (summary: ITransactionPricesSummary): ITransactionPricesGapNote | null => {
    const {widestGaps, narrowestGaps} = summary;

    if (widestGaps.length === 0) {
        return null;
    }

    return {
        widestPreposition: cityPronounWhere(widestGaps[0].name),
        widestCities: widestGaps.map(toGapCity),
        narrowestCities: narrowestGaps.map(toGapCity)
    };
};
